import { isNaN, round } from 'lodash'
import React from 'react'
import { Row, Text } from '@/components/core'

type ColorType = 'red' | 'green' | 'white'

export interface ConversationAnalysisProps {
  items?: { id: string; label: string; value: number; color?: ColorType }[]
}

export const ConversationAnalysis: React.FC<ConversationAnalysisProps> = ({
  items
}) => {
  return (
    <Row className="mt-6 flex-wrap gap-x-4 gap-y-3">
      {items?.map(({ id, label, value }) => (
        <Row
          key={id}
          className="h-14 min-w-[166px] min-w-fit items-center gap-x-2 rounded-2xl border border-gray-50 bg-white px-3 max-lg:flex-1"
        >
          <Text className="text-xl font-bold text-gray-600">
            {!isNaN(Number(value)) ? round(value, 1) : value}
          </Text>
          <Text.Translated
            translationKey={label}
            className="text-md text-gray-600"
          />
        </Row>
      ))}
    </Row>
  )
}

export default ConversationAnalysis
